/* The checkout's review line, request note and submit (prototype .visitLine, .reqNote, .coSubmit), in the telify layer. */
@layer telify {
  .line {
    padding: 16px 0;
    border-top: var(--line);
    border-bottom: var(--line);
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 15.5px;
  }

  .line span {
    color: var(--text-tertiary);
    font-size: 14px;
    display: block;
    margin-top: 3px;
  }

  .line b {
    font-weight: 600;
  }

  .note {
    margin-top: 18px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    font-size: 15px;
    line-height: 1.5;
    color: var(--text-secondary);
  }

  .note svg {
    margin-top: 3px;
    color: var(--text-muted);
  }

  .submit {
    margin-top: 32px;
    padding-top: 26px;
    border-top: var(--line);
  }

  /* No note between them: the price line's own bottom rule is the one divider, not a second one after an empty band. */
  .line + .submit {
    margin-top: 26px;
    padding-top: 0;
    border-top: 0;
  }

  .problem {
    margin-bottom: 14px;
    font-size: 14.5px;
    color: var(--danger);
  }

  .confirm {
    width: 100%;
  }

  /* A booking that did not go through (row V7). */
  .failure {
    display: grid;
    gap: 10px;
    font-size: 15px;
    color: var(--text-secondary);
  }

  .failureTitle {
    font-size: 20px;
    color: var(--text-primary);
  }

  .failureActions {
    display: flex;
    gap: 12px;
    margin-top: 12px;
  }
}
